<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-bottom: 10px">
          <el-tabs>
            <el-tab-pane label="回复">
              <div v-if="isReject || isClosed">
                <el-button
                  :disabled="isClosed || isReject"
                  @click="closeWork"
                  size="small"
                  type="primary"
                >
                  {{ isClosed ? "已关闭" : "关闭工单" }}
                </el-button>
              </div>
              <template v-if="!isClosed && !isReject">
                <div class="quill-editor-box">
                  <quill-editor
                    :content="contents"
                    :options="editorOption"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <span class="quill-text-limit">{{ quillLength }} / 1000</span>
                </div>
                <div class="quill-editor-options-box">
                  <div class="upload-file">
                    <el-upload
                      ref="upload"
                      accept=".txt,.zip,.rar,.pdf,.doc,.docx"
                      :action="upload_url"
                      :on-remove="handleRemove"
                      :limit="1"
                      :before-upload="handleBeforeUpload"
                      :on-exceed="handleOnExceed"
                      :http-request="uploadSectionFile"
                      :file-list="fileList"
                    >
                      <span class="upload-text-btn color-blue c-pointer"
                        >上传附件<i class="el-icon-paperclip"
                      /></span>
                      <span slot="tip" class="upload-limit"
                        >单个文件不能超过20MB</span
                      >
                    </el-upload>
                    <!--          <span v-if="files.length !== 0">{{ size }}</span>-->
                    <div class="upload-img">
                      <span class="upload-text-btn color-blue label"
                        >图片上传：</span
                      >
                      <upload
                        :limit="9"
                        v-model="upload.imgs"
                        :default="upload.defaultImgs"
                        :multiple="true"
                        ref="upload1"
                        :isShowCrop="false"
                        :extensions="upload.extensions"
                      />
                    </div>
                  </div>
                  <div class="quill-editor-button-box">
                    <el-button
                      :disabled="isClosed || isReject"
                      @click="closeWork"
                      size="small"
                      type="primary"
                    >
                      {{ isClosed ? "已关闭" : "关闭工单" }}
                    </el-button>
                    <el-button
                      :disabled="isClosed || isReject"
                      @click="dealWorkOrderByIdNew()"
                      size="small"
                      type="primary"
                    >
                      {{ isWait ? "回复" : "提交" }}
                    </el-button>
                  </div>
                </div>
              </template>
            </el-tab-pane>
            <el-tab-pane label="标签"></el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";
import workOrderInfo from "components/workOrderDetail/workOrderInfo";
import recordItem from "components/workOrderDetail/recordItem";
import pagination from "components/pagination";
import upload from "components/upload";
import { quillEditor, Quill } from "vue-quill-editor";
import VideoBlot from "plus/plugins";
import http from "plus/http";
import axios from "axios";

//Quill.register(VideoBlot);
export default {
  name: "workmange.workOrderList.reply",
  components: {
    workOrderInfo,
    recordItem,
    quillEditor,
    pagination,
    upload,
  },
  data() {
    return {
      contents: "",
      editorOption: {
        placeholder: "请输入正文内容，不超过1000字",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ script: "sub" }, { script: "super" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            ["clean"],
            // ["link", "image", "video"],
          ],
        },
      },
      recordType: "1",
      quillLength: 0,
      upload_url: "https://up.qbox.me",
      file_url: "https://cdn-workorder.meb.com/",
      wkDetailInfo: {},
      recordList: [],
      recordTotalCount: 0,
      fileList: [],
      files: [],
      size: "",
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      text: "",
      upload: {
        imgs: [],
        defalutImgs: [],
        extensions: [
          {
            isActive: false,
            icon: "el-icon-star-off",
            activeIcon: "el-icon-star-on",
            style: "",
            activeStyle: "",
            click(img) {
              this.isActive = !this.isActive;
            },
          },
        ],
      },
      fileFlag: true,
      // fileType:['.rar','.zip','.txt','.doc','.docx','xlsx','xls','pdf']
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    isClosed() {
      return parseInt(this.wkDetailInfo.status) === 2;
    },
    isReject() {
      return parseInt(this.wkDetailInfo.status) === 3;
    },
    isWait() {
      return parseInt(this.wkDetailInfo.status) === 1;
    },
  },
  activated() {
    this.getManageWorkOrderDetail();
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    resetData() {
      this.contents = "";
      this.upload_url = "https://up.qbox.me";
      this.file_url = "https://cdn-workorder.meb.com/";
      this.wkDetailInfo = {};
      this.recordList = [];
      this.recordTotalCount = 0;
      this.fileList = [];
      this.files = [];
      this.size = "";
      this.upload = {
        imgs: [],
        defalutImgs: [],
        extensions: [
          {
            isActive: false,
            icon: "el-icon-star-off",
            activeIcon: "el-icon-star-on",
            style: "",
            activeStyle: "",
            click(img) {
              this.isActive = !this.isActive;
            },
          },
        ],
      };
      this.quillLength = 0;
    },
    getManageWorkOrderDetail() {
      return api.workmanage
        .getManageWorkOrderDetail({ workOrderId: this.wkOrderId })
        .then((res) => {
          const data = res.data.data;
          this.wkDetailInfo = {
            wkOrderId: data.wkOrderId,
            wkType: data.qaTypeName,
            status: data.statusStr,
            authorName: data.authorName,
            createdTime: data.created,
            desc: data.remark,
            wkOrderTopic: data.wkOrderTopic,
            appendixInfos: data.appendis,
            acceptorName: data.acceptorName,
            relationUserList: data.relationUserList,
            relationWorkOrderId: data.relationWorkOrderId,
            customerList: data.customerList,
            qaProcessType: data.qaProcessType,
            handleResult: data.handleResult,
          };
        })
        .catch((err) => {});
    },
    handleOnExceed() {
      this.$message.warning("只能上传一个附件！");
    },
    // 文件移除事件
    handleRemove() {
      this.files = [];
    },
    handleBeforeUpload(file) {
      this.fileFlag = false;
      this.uploading = true;
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (file.size < 1024) {
        this.size = file.size + "B";
      } else if (file.size < 1024 * 1024) {
        this.size = file.size / 1024 + "KB";
      } else {
        this.size = (file.size / 1024 / 1024).toFixed(2) + "MB";
      }

      const fileType =
        file.name.endsWith(".rar") ||
        file.name.endsWith(".zip") ||
        file.name.endsWith(".txt") ||
        file.name.endsWith(".doc") ||
        file.name.endsWith(".docx") ||
        file.name.endsWith(".xls") ||
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".pdf");
      if (!fileType) {
        this.$message({
          message: "请检查上传文件类型!",
          type: "warning",
        });
        return fileType;
      }

      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 20MB!",
          type: "warning",
        });
        return isLt2M;
      }
    },
    uploadSectionFile: function (params) {
      var self = this,
        file = params.file,
        fileType = file.type,
        file_url = self.$refs.upload.uploadFiles[0].url;
      self.uploadFile(file);
    },
    uploadFile: function (file) {
      let self = this;
      api.qiniu.getToken({ fileName: file.name }).then((res) => {
        let index = file.name.lastIndexOf(".");
        let name = file.name.substr(index);
        this.token = res.data.data.token;
        this.fileName = res.data.data.fileName;
        this.fileName += name;
        let formData = new FormData();
        formData.append("token", this.token);
        formData.append("key", this.fileName);
        formData.append("file", file);
        axios
          .post(self.upload_url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(function (res) {
            let list = {
              url: self.file_url + res.data.key,
              type: "FILE",
            };
            self.files.push(list);
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(() => {
            this.fileFlag = true;
          });
      });
    },
    onEditorChange({ quill, html, text }) {
      const textLimit = 1000;
      if (text.length <= textLimit) {
        this.contents = html;
        this.text = text;
      } else {
        const range = quill.getLength();
        quill.deleteText(textLimit, range);
      }
      this.quillLength = quill.getLength() - 1;
    },
    closeWork() {
      this.$confirm("是否解决了您的问题", "关闭工单", {
        confirmButtonText: "解决了",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "未解决",
        type: "warning",
      })
        .then(() => {
          api.work.closeWork({ wkOrderId: this.wkOrderId }).then((res) => {
            this.getManageWorkOrderDetail();
          });
        })
        .catch((err) => {});
    },
    dealWorkOrderByIdNew() {
      if (!this.fileFlag) {
        return this.$message.warning("附件正在上传中....");
      }
      for (let item of this.upload.imgs) {
        if (!item.loading) {
          item.url = this.file_url + item.url;
        } else {
          return this.$message.warning("图片正在上传中....");
        }
      }
      const tempPara = {
        attachments: this.files.concat(this.upload.imgs),
        remark: this.contents.trim() ? this.contents : "",
        status: 1,
        workOrderId: this.wkOrderId,
      };
      if (!this.text.trim()) {
        this.$message.warning("请填写反馈信息！");
      } else {
        api.work
          .dealWorkOrderById(tempPara)
          .then((res) => {
            if (res.data.success) {
              this.$message.success("操作成功！");
              this.getManageWorkOrderDetail();
              this.files = [];
              this.fileList = [];
              this.contents = "";
              this.upload.imgs = [];
              this.$refs.upload1.clearAll();
            }
          })
          .catch((err) => {});
      }
    },
    timestampToTime(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + "-";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      const D = date.getDate() + " ";
      const h = date.getHours() + ":";
      const m = date.getMinutes() + ":";
      const s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .quill-editor-container {
    padding-bottom: 32px;

    .quill-editor-box {
      position: relative;

      .quill-editor {
        padding: 20px 47px 20px 95px;
        height: 365px;

        /deep/ .ql-container {
          height: calc(100% - 42px);
        }
      }

      .quill-text-limit {
        position: absolute;
        bottom: 30px;
        right: 60px;
        color: #888;
      }
    }

    .quill-editor-options-box {
      display: flex;
      justify-content: space-between;
      //align-items: center;
      align-items: flex-end;
      padding-left: 95px;
      padding-right: 47px;

      /deep/ .upload-file {
        font-size: 14px;

        .el-upload-list {
          padding-left: 78px;
        }

        .upload-img {
          display: flex;
          margin-top: 10px;

          .label {
            display: inline-block;
            width: 100px;
            margin-right: 12px;
            box-sizing: border-box;
            color: #3572e2;
          }
        }

        .upload-text-btn {
          color: #3572e2;
          margin-right: 12px;
        }

        .upload-limit {
          color: #999;
        }
      }

      .quill-editor-button-box {
        .el-button {
          width: 104px;
          height: 36px;
          border-radius: 2px;
          font-size: 14px;
        }
      }
    }
  }

  .record {
    width: 100%;
    margin-top: 30px;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
